export type HandSide = 'left' | 'right'
export type JointId =
  | 'joint_1'
  | 'joint_2'
  | 'joint_3'
  | 'joint_4'
  | 'joint_5'
  | 'joint_6'
  | 'joint_7'
  | 'joint_8'
  | 'joint_9'
  | 'joint_10'
  | 'joint_11'
  | 'joint_12'
  | 'joint_13'
  | 'joint_14'

export type JointAnatomicalId =
  | 'pinky_pip'
  | 'pinky_mcp'
  | 'pinky_base'
  | 'ring_pip'
  | 'ring_mcp'
  | 'ring_base'
  | 'middle_pip'
  | 'middle_mcp'
  | 'middle_base'
  | 'index_pip'
  | 'index_mcp'
  | 'index_base'
  | 'thumb_mcp'
  | 'thumb_cmc'

type JointBase = { id: JointId; anatomicalId: JointAnatomicalId; label: string }
export type JointDefinition = JointBase & { x: number; y: number }

const JOINT_BASE: JointBase[] = [
  { id: 'joint_1', anatomicalId: 'pinky_pip', label: 'Pinky PIP' },
  { id: 'joint_2', anatomicalId: 'pinky_mcp', label: 'Pinky MCP' },
  { id: 'joint_3', anatomicalId: 'pinky_base', label: 'Pinky Base' },
  { id: 'joint_4', anatomicalId: 'ring_pip', label: 'Ring PIP' },
  { id: 'joint_5', anatomicalId: 'ring_mcp', label: 'Ring MCP' },
  { id: 'joint_6', anatomicalId: 'ring_base', label: 'Ring Base' },
  { id: 'joint_7', anatomicalId: 'middle_pip', label: 'Middle PIP' },
  { id: 'joint_8', anatomicalId: 'middle_mcp', label: 'Middle MCP' },
  { id: 'joint_9', anatomicalId: 'middle_base', label: 'Middle Base' },
  { id: 'joint_10', anatomicalId: 'index_pip', label: 'Index PIP' },
  { id: 'joint_11', anatomicalId: 'index_mcp', label: 'Index MCP' },
  { id: 'joint_12', anatomicalId: 'index_base', label: 'Index Base' },
  { id: 'joint_13', anatomicalId: 'thumb_mcp', label: 'Thumb MCP' },
  { id: 'joint_14', anatomicalId: 'thumb_cmc', label: 'Thumb CMC' }
]

const JOINT_COORDS: Record<HandSide, Record<JointId, { x: number; y: number }>> = {
  left: {
    joint_1: { x: 6.1, y: 32 },
    joint_2: { x: 11, y: 41 },
    joint_3: { x: 19, y: 53 },
    joint_4: { x: 22.8, y: 21 },
    joint_5: { x: 25, y: 31 },
    joint_6: { x: 28, y: 46 },
    joint_7: { x: 42.3, y: 14 },
    joint_8: { x: 42.5, y: 26 },
    joint_9: { x: 43, y: 43.3 },
    joint_10: { x: 64, y: 20 },
    joint_11: { x: 61.7, y: 32 },
    joint_12: { x: 59.2, y: 44 },
    joint_13: { x: 86, y: 56 },
    joint_14: { x: 72, y: 70 }
  },
  right: {
    joint_1: { x: 93.9, y: 32 },
    joint_2: { x: 88.7, y: 41 },
    joint_3: { x: 81.5, y: 53 },
    joint_4: { x: 77, y: 21 },
    joint_5: { x: 75.1, y: 31 },
    joint_6: { x: 72, y: 46.5 },
    joint_7: { x: 57.7, y: 14 },
    joint_8: { x: 57.5, y: 26 },
    joint_9: { x: 57, y: 44 },
    joint_10: { x: 36, y: 20 },
    joint_11: { x: 38.6, y: 32 },
    joint_12: { x: 40.8, y: 44 },
    joint_13: { x: 15, y: 56.5 },
    joint_14: { x: 28, y: 70 }
  }
}

export const JOINT_DEFINITIONS: Record<HandSide, JointDefinition[]> = {
  left: JOINT_BASE.map((joint) => ({ ...joint, ...JOINT_COORDS.left[joint.id] })),
  right: JOINT_BASE.map((joint) => ({ ...joint, ...JOINT_COORDS.right[joint.id] }))
}

export const JOINT_ID_TO_ANATOMICAL: Record<JointId, JointAnatomicalId> = JOINT_BASE.reduce(
  (acc, joint) => {
    acc[joint.id] = joint.anatomicalId
    return acc
  },
  {} as Record<JointId, JointAnatomicalId>
)

export const JOINT_LABEL_BY_ANATOMICAL: Record<JointAnatomicalId, string> = JOINT_BASE.reduce(
  (acc, joint) => {
    acc[joint.anatomicalId] = joint.label
    return acc
  },
  {} as Record<JointAnatomicalId, string>
)

export const JOINT_ANATOMICAL_IDS = JOINT_BASE.map((joint) => joint.anatomicalId)
